import { render, staticRenderFns } from "./gaokaoZts.vue?vue&type=template&id=37a00cec&scoped=true"
import script from "./gaokaoZts.vue?vue&type=script&lang=js"
export * from "./gaokaoZts.vue?vue&type=script&lang=js"
import style0 from "./gaokaoZts.vue?vue&type=style&index=0&id=37a00cec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a00cec",
  null
  
)

export default component.exports